import React, { useState, useEffect } from "react";
import "./DietsProgram.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import dietsFAQ from "./dietsFAQ";
import ProgramBanner from "../../Components/ProgramBanner/ProgramBanner";
import FAQ from "../../Components/FAQ/FAQ";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function DietsProgram() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const [dietPlan, setDietPlan] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDietPlanList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/diet_plan_list`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setDietPlan(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting diet plan list", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      }
    };
    if (userToken) {
      fetchDietPlanList();
    }
  }, [baseUrl, userToken]);

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">برنامه تغذیه</div>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <div className="dietsProgramBanner horizontalBorder">
                {dietPlan.diet !== null && (
                  <ProgramBanner label="diet" {...dietPlan.diet} />
                )}
                {dietPlan.support !== null && (
                  <ProgramBanner label="diet" {...dietPlan.support} />
                )}
              </div>
              <div className="dietsProgramFAQWrapper responsiveWidth">
                {dietsFAQ.map((faq) => (
                  <FAQ key={faq.id} {...faq} />
                ))}
              </div>
            </>
          )}
          <Alert
            showAlert={showAlert}
            alertText="خطا در برقراری ارتباط"
            bottom="5rem"
          />
        </div>
      </div>
    </div>
  );
}
